import { Accessory } from "db";
import { motion } from "framer-motion";
import * as React from "react";

import { styled } from "../../theme";

import { useProductDispatch } from "context/AppContext";
import SingleOption from "./SingleOption";
import MultiOption from "./MultiOption";

export interface Props {
  index: number;
  groupIndex: number;
  accessory: Accessory;
}

export default function AccessoryItem({ groupIndex, index, accessory }: Props) {
  const dispatch = useProductDispatch();
  let options = accessory.options;

  return (
    <Container variants={variants}>
      {options.length === 1 ? (
        <SingleOption
          option={options[0]}
          setOption={(b) => {
            dispatch({ type: "setOption", groupIndex, accessoryIndex: index, optionIndex: 0, b });
          }}
        />
      ) : (
        <MultiOption
          title={accessory.name}
          options={options}
          selectOption={(n: number) => {
            dispatch({ type: "selectOption", groupIndex, accessoryIndex: index, optionIndex: n });
          }}
          clearOptions={() => {
            options.forEach((op, n) => {
              dispatch({ type: "setOption", groupIndex, accessoryIndex: index, optionIndex: n, b: false });
            });
          }}
        />
      )}
    </Container>
  );
}

const Container = motion.custom(styled.div`
  display: flex;
  align-items: stretch;
  overflow: hidden;

  padding: 12px 0;
`);

const variants = {
  open: {
    x: 0,
    opacity: 1,
    transition: {
      x: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    x: 500,
    opacity: 0,
    transition: {
      x: { stiffness: 1000 }
    }
  }
};
